<template>
  <div class="project-team">
    <h3 class="title">主施工合同</h3>
    <el-table :data="fatherData" style="width: 100%" v-loading="loading">
      <el-table-column label="合同名称">
        <template slot-scope="scope">
          <span v-html="getTypeName(scope.row.type)"></span>
          <span>{{ scope.row.name }}</span>
          <!-- <router-link :to="'/Contract/Detail/'+scope.row.id" class="link" target="_blank">{{ scope.row.name }}</router-link> -->
        </template>
      </el-table-column>
      <el-table-column prop="departmentVO.name" label="所属公司" width="180px">
      </el-table-column>
      <el-table-column label="合同类型" width="100px">
        <template slot-scope="scope">
          {{ contractTypeName[scope.row.type] }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="80px">
      </el-table-column>
      <el-table-column label="创建人" width="150px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="120px">
      </el-table-column>

      <el-table-column label="操作" width="110px">
        <template slot-scope="scope">
          <router-link target="_blank" :to="'/Contract/Detail/' + scope.row.id">
            <el-button plain size="mini">详情</el-button>
          </router-link>
        </template>
      </el-table-column>
    </el-table>

    <h3 class="title" style="margin-top:20px;">子项目合同</h3>
    <el-table :data="childData" style="width: 100%" v-loading="loading">
      <el-table-column label="合同名称">
        <template slot-scope="scope">
          <span v-html="getTypeName(scope.row.type)"></span>
          <span>{{ scope.row.name }}</span>
          <!-- <router-link :to="'/Contract/Detail/'+scope.row.id" class="link" target="_blank">{{ scope.row.name }}</router-link> -->
        </template>
      </el-table-column>
      <el-table-column prop="departmentVO.name" label="所属公司" width="180px">
      </el-table-column>
      <el-table-column label="合同类型" width="100px">
        <template slot-scope="scope">
          {{ contractTypeName[scope.row.type] }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="80px">
      </el-table-column>
      <el-table-column label="创建人" width="150px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="120px">
      </el-table-column>

      <el-table-column label="操作" width="110px">
        <template slot-scope="scope">
          <router-link target="_blank" :to="'/Contract/Detail/' + scope.row.id">
            <el-button plain size="mini">详情</el-button>
          </router-link>
        </template>
      </el-table-column>
    </el-table>

    <h3 class="title" style="margin-top:20px;">其他合同</h3>
    <el-table :data="otherData" style="width: 100%" v-loading="loading">
      <el-table-column label="合同名称">
        <template slot-scope="scope">
          <span v-html="getTypeName(scope.row.type)"></span>
          <router-link :to="'/Contract/Detail/'+scope.row.id" class="link" target="_blank">{{ scope.row.name }}</router-link>
        </template>
      </el-table-column>
      <el-table-column prop="departmentVO.name" label="所属公司" width="180px">
      </el-table-column>
      <el-table-column label="合同类型" width="100px">
        <template slot-scope="scope">
          {{ contractTypeName[scope.row.type] }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="80px">
      </el-table-column>
      <el-table-column label="创建人" width="150px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="120px">
      </el-table-column>

      <el-table-column label="操作" width="110px">
        <template slot-scope="scope">
          <router-link target="_blank" :to="'/Contract/Detail/' + scope.row.id">
            <el-button plain size="mini">详情</el-button>
          </router-link>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  export default {
    components: {
      UserInfo,
    },
    props: ['projectId'],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
      })
    },
    data() {
      return {
        // 列表
        loading: true,
        childData: [],
        fatherData: [],
        otherData: [],

        // typeName
        typeName: ['合同', '工程合同', '子项目'],
        contractTypeName: ['独立合同', '工程施工合同', '子项目合同'],
      }
    },
    mounted() {
      // 获取列表
      this.getLists()
    },
    methods: {
      getTypeName(type) {
        return '<span class="approval-type at' + type + '">' + this.typeName[type] + '</span>'
      },
      projectDetail(row) {
        console.log(row.id)
        this.$router.push("/Project/Detail/" + row.id)
      },
      // 获取列表
      getLists() {
        ajax.get('/contract/project/relate/list/', {
          projectId: this.projectId
        }, (res) => {
          this.loading = false

          let _vo = res.vo
          this.fatherData.push(_vo.parentContracts)
          if (!_vo.parentContracts.name) {
            this.fatherData = []
          }
          this.childData = _vo.childContracts
          this.otherData = _vo.otherContracts
        })
      },
    },
    watch: {}
  };
</script>


// WEBPACK FOOTER //
// src/page/project/contractlist.vue